module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-sortie.8e8ce6fa.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/UnavailableBattle/images/bg-sortie.png
// module id = 2529
// module chunks = 11